import React from 'react'
import "../CSS/Skill.css"
const Cards = (props) => {
    return (
        <>
        <div className="skill-box">
                    <div className="skill-title">
                        <div className="img">
                            <img src={props.imgsrc} alt="css" className="skill-icon"/>
                        </div>
                        <h2>{props.title}</h2>
                    </div> 
                    <p>
                    {props.per}
                    </p>       
                </div>
        </>
    )
}

export default Cards